import { render } from "./Chat.vue?vue&type=template&id=6e1d8b60&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=6e1d8b60&scoped=true&lang=css"
import "./Chat.vue?vue&type=style&index=1&id=6e1d8b60&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1d8b60"]])

export default __exports__